module.exports = __webpack_public_path__ + "img/1024.c30881c2.svg";